import { defineMessages, useIntl } from 'react-intl';
import { Alert } from '@cbhq/cds-web/overlays';

type RemoveMemberModalProps = {
  visible: boolean;
  onClose: () => void;
  memberName: string;
  onConfirm: () => void;
};

const messages = defineMessages({
  removeMemberModalTitle: {
    id: 'Team.removeMemberModalTitle',
    defaultMessage: 'Remove team member?',
    description: 'Remove member modal title',
  },
  removeMemberModalDescription: {
    id: 'Team.removeMemberModalDescription',
    defaultMessage: "{memberName} will no longer have access to any of your company's data.",
    description: 'Remove member modal description',
  },
  removeMemberModalButton: {
    id: 'Team.removeMemberModalButton',
    defaultMessage: 'Remove',
    description: 'Remove member modal button',
  },
  removeMemberModalCancel: {
    id: 'Team.removeMemberModalCancel',
    defaultMessage: 'Cancel',
    description: 'Remove member modal cancel',
  },
});

export function RemoveMemberAlert({
  visible,
  onClose,
  memberName,
  onConfirm,
}: RemoveMemberModalProps) {
  const { formatMessage } = useIntl();

  return (
    <Alert
      title={formatMessage(messages.removeMemberModalTitle)}
      body={formatMessage(messages.removeMemberModalDescription, {
        memberName,
      })}
      pictogram="idError"
      visible={visible}
      onRequestClose={onClose}
      preferredActionLabel={formatMessage(messages.removeMemberModalButton)}
      onPreferredActionPress={onConfirm}
      dismissActionLabel={formatMessage(messages.removeMemberModalCancel)}
      onDismissActionPress={onClose}
      preferredActionVariant="negative"
      actionLayout="vertical"
      testID="team-member-remove-alert"
    />
  );
}
